export default "__VITE_ASSET__8bbfc416__"